import { useQuery } from "@tanstack/react-query";
import { getHotelExtra } from "../../api/apiHotelExtras";

const QUERY_KEY = ["hotelExtra"];

const useGetHotelExtra = (id) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => getHotelExtra(id),
    enabled: !!id,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelExtra: data?.data || null,
  };
};

export default useGetHotelExtra;
